import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchDashboardData } from '../api/dashboardApi';
import { buildDashboardStats } from '../model/dashboardModel';

export function useDashboardStats() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [errors, setErrors] = useState([]);

  const numberFormatter = useMemo(() => new Intl.NumberFormat('es-ES'), []);

  const refresh = useCallback(async () => {
    setLoading(true);

    try {
      const { payload, errors: loadErrors } = await fetchDashboardData();
      setStats(buildDashboardStats(payload));
      setErrors(loadErrors);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Dashboard: error inesperado', error);
      setErrors(['No se pudieron cargar los datos del dashboard.']);
      setStats(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    loading,
    stats,
    errors,
    refresh,
    numberFormatter,
  };
}
